import ContentItem from "./content-item";

const getContentItemsIds = (items: Set<ContentItem>): Array<ContentItem["value"]["id"]> => {
  return [...items].map((item) => item.value.id);
};

export default getContentItemsIds;
